<script lang="ts" setup>
import InlineSvg from 'vue-inline-svg'
import spinner from '@/assets/images/spinner.svg'
</script>

<template>
    <InlineSvg :src="spinner" />
</template>
